import { onDocumentReady } from "@story/story_assets";

onDocumentReady(function() {

	const activeClass = "fw-shadow-bold";

	let map = new Map();
	for (let element of document.querySelectorAll("[id][data-scroll-spy='title']")) {
		map.set(element, {
			element: element,
			targets: document.querySelectorAll("[href='#" + element.getAttribute('id') + "']"),
			isIntersecting: false,
			isActive: false
		});
	}

	function updateActive() {
		let lastIntersectingItem = null;
		let lastActiveItem = null;
		for (let item of map.values()) {
			if (item.isIntersecting && lastIntersectingItem === null) {
				lastIntersectingItem = item;
			}
			if (item.isActive) {
				lastActiveItem = item;
			}
			item.isActive = false;
		}

		if (lastIntersectingItem !== null) {
			lastIntersectingItem.isActive = true;
		}
		else if (lastActiveItem !== null) {
			lastActiveItem.isActive = true;
		}

		for (let item of map.values()) {
			for (let target of item.targets) {
				target.classList.toggle(activeClass, item.isActive);
			}
		}
	}

	function callback(entries, observer) {
		for (let entry of entries) {
			let item = map.get(entry.target);
			item.isIntersecting = entry.isIntersecting;
		}

		updateActive();
	}

	let observer = new IntersectionObserver(callback, {
		rootMargin: "0px 0px -25%",
		threshold: [0.1, 0.5, 1]
	});

	for (let element of map.values()) {
		observer.observe(element.element);
	}
});